﻿<script setup>
import {defineModel, defineProps} from "vue";
import { vMaska } from "maska/vue";
import ReferralFormLabel from "@/components/ReferralFormLabel.vue";
import rules from "@/utils/validationRules.js";

const model = defineModel()

defineProps({
  related: {
    type: Boolean,
    default: false,
    description: 'Some contacts are related, these have a relationship field. Otherwise company field'
  },
  title: {
    type: String,
    required: true,
  }
})

</script>

<template>
  <v-row>
    <v-col cols="12" class="py-0 mb-1 text-overline">
      {{title}}
    </v-col>
  </v-row>
  <v-row>
    <v-col cols="12" md="4"  class="py-0">
      <ReferralFormLabel required>Name</ReferralFormLabel>
      <v-text-field v-model="model.name" required :rules="[rules.required]"/>
    </v-col>
    <v-col cols="12" md="4"  class="py-0">
      <ReferralFormLabel required v-if="!related">Company</ReferralFormLabel>
      <v-text-field v-model="model.company" required v-if="!related" :rules="[rules.required]"/>
      
      <ReferralFormLabel required v-if="related">Relationship to Participant</ReferralFormLabel>
      <v-text-field v-model="model.relation" required v-if="related" :rules="[rules.required]"/>
    </v-col>  
  </v-row>
  
  <v-row>
    <v-col cols="12" md="4"  class="py-0">
      <ReferralFormLabel required>Mobile/Phone</ReferralFormLabel>
      <v-text-field v-model="model.phone" required inputmode="numeric" type="text" v-maska="'###############'" :rules="[rules.required, rules.phone]"/>
    </v-col>
    <v-col cols="12" md="4"  class="py-0">
      <ReferralFormLabel required>Email</ReferralFormLabel>
      <v-text-field v-model="model.email" required inputmode="email" type="email" :rules="[rules.required, rules.email]"/>
    </v-col>  
  </v-row>
</template>

<style scoped>

</style>
